import Icon from "@/components/common/Icon"
import { toKoreanFullDate } from "@/domain/common/utils/DateUtils"
import type { AdminAccount } from "@/domain/admin/model/Admin"

interface AdminHeaderProps {
  todayIso: string
  account: AdminAccount
  onOpenSidebar: () => void
  onLogout: () => void
}

export default function AdminHeader({
  todayIso,
  account,
  onOpenSidebar,
  onLogout,
}: Readonly<AdminHeaderProps>) {
  function onClickOpenSidebar() {
    onOpenSidebar()
  }

  function onClickLogout() {
    onLogout()
  }

  return (
    <header
      role="banner"
      className="sticky top-0 z-20 flex h-20 items-center justify-between border-b border-app-secondary-500 bg-app-secondary-100 px-5 sm:px-8"
    >
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onClickOpenSidebar}
          aria-label="메뉴 열기"
          className="focus-ring cursor-pointer p-2 text-app-text-300 transition hover:bg-app-secondary-300 lg:hidden"
        >
          <Icon name="menu" />
        </button>
        <div>
          <p className="app-txt-caption text-app-text-200">
            {toKoreanFullDate(todayIso)}
          </p>
          <h1 className="app-txt-h3 mt-0.5 font-black">대회 운영 현황</h1>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <span className="hidden text-right sm:block">
          <strong className="app-txt-body2 block font-bold">
            {account.name}
          </strong>
          <span className="app-txt-caption block font-medium text-app-text-200">
            {account.roleLabel}
          </span>
        </span>
        <span
          aria-hidden="true"
          className="app-txt-body2 flex size-10 items-center justify-center bg-app-primary-500 font-black text-app-text-100"
        >
          {account.name.slice(0, 1)}
        </span>
        <button
          type="button"
          onClick={onClickLogout}
          aria-label="로그아웃"
          className="focus-ring cursor-pointer p-2 text-app-text-200 transition hover:bg-app-secondary-300 hover:text-app-text-400"
        >
          <Icon
            name="logout"
            size={19}
          />
        </button>
      </div>
    </header>
  )
}
